<template>
    <div>
        <Template1 :code="Code" />

        <div v-if="Template == 42">
            <img style="display: block; margin: 4rem auto; width: 20rem;" src="../assets/img/SWAN-LOGO.webp" />
            <h2 style="text-align: center; width: 90%; margin: 0 auto;">Estamos preparando tu link ilimitado 🦢💕✨ </h2>
            <h2 style="text-align: center; width: 90%; margin: 0 auto;">¡Gracias por tu espera!</h2>
        </div>
    </div>
</template>

<script>
import Template1 from '@/components/Templates/Template1.vue';

import axios from 'axios';
import moment from 'moment';

export default {
    name: 'Wedding',
    components: {
        Template1,
    },
    data() {
        return {
            preload: true,
            Code: 'BodaAvilesMembreno-89',
            Template: 0
        }
    },
    methods: {
        goToInvitation() {
            setTimeout(function () {
                this.preload = false
            }.bind(this), 6500);
        },

        GetTemplateEvent() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}Template/GetTemplateEvent/${this.Code}` : `${process.env.VUE_APP_API_PRO}Template/GetTemplateEvent/${this.Code}`;
            axios.get(url)
                .then((response) => this.Template = response.data.IdPlantilla)
                .catch(err => console.error(err));
        },
        saveLog() {
            const browserName = navigator.userAgent;
            const parsedBrowser = (browserName.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [])[1];
            const parsedVersion = parsedBrowser == 'Chrome' ? (browserName.match(/Chrome\/(\d+)/)[1]) : (browserName.match(/version\/(\d+)/i) || [])[1];
            const osName = navigator.platform;

            const url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}logsAccess` : `${process.env.VUE_APP_API_PRO}logsAccess`;
            const data = {
                Browser: parsedBrowser,
                Version: parsedVersion,
                OsName: osName,
                ts: moment(new Date()).locale("es-mx").format("YYYY-MM-DD H:mm"),
                Code: this.Code
            }
            axios.post(url, data)
            .then(() => {
            }).catch((err) => console.error(err));
        }
    },
    created() {
        this.GetTemplateEvent();
        this.goToInvitation();
        this.saveLog()
    },
}
</script>

<style scoped>
.template {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 1rem;
    width: 85%;
    margin: 2rem auto 2rem auto;
    justify-items: center;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@font-face {
    font-family: "swanmoment";
    src: url("../assets/fonts/swanmoment.woff2");
}
</style>